import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { Link, Navigate } from "react-router-dom";

export default class Products extends Component {
  state = {
    products: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    notiColor: "success",
    message: "",
    loading: false,
    redirect: false,
  };

  componentDidMount() {
    this.getAllProducts(this.state.page_no, this.state.per_page);
  }

  /* =============================
     FETCH PRODUCTS
  ============================= */
  getAllProducts = (page = 1, limit = 20) => {
    if (init() !== "success") return this.setState({ redirect: true });

    this.setState({ loading: true });

    axios
      .get(`${Constants.getUrls.getAllProducts}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const data = resp.data.data;

          this.setState({
            products: data.docs || [],
            pagination: {
              page: data.page,
              limit: data.limit,
              totalDocs: data.totalDocs,
              totalPages: data.totalPages,
              hasNextPage: data.hasNextPage,
              hasPrevPage: data.hasPrevPage,
              nextPage: data.nextPage,
              prevPage: data.prevPage,
            },
            page_no: data.page,
            loading: false,
          });
        } else {
          this.showSnackbar("warning", "Failed to load products");
        }
      })
      .catch(() => {
        this.showSnackbar("warning", "Something went wrong");
      });
  };

  /* =============================
     DELETE PRODUCT
  ============================= */
  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    axios
      .delete(Constants.deleteUrls.deleteProduct + id)
      .then((resp) => {
        this.showSnackbar("success", resp.data?.message || "Product deleted");
        this.getAllProducts(this.state.pagination.page, this.state.per_page);
      })
      .catch(() => {
        this.showSnackbar("warning", "Delete failed");
      });
  };

  /* =============================
     PAGINATION
  ============================= */
  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllProducts(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllProducts(newPage, this.state.per_page);
  };

  showSnackbar = (color, message) => {
    this.setState({ notification: true, notiColor: color, message });
    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 2500);
  };

  /* =============================
     RENDER
  ============================= */
  render() {
    const { products, pagination, loading, redirect } = this.state;

    if (redirect) return <Navigate to="/signin" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Products
              </MDTypography>
            </MDBox>

            {/* CREATE BUTTON */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addNewProduct">
                <MDButton variant="contained" size="small" color="primary">
                  Add Product
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : products.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Product Name", accessor: "name" },
                      { Header: "Image", accessor: "image" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: products.map((product, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit +
                        (index + 1),

                      name: product.product_name || "—",

                      image: product.product_images?.length ? (
                        <img
                          src={
                            Constants.imageDomain +
                            product.product_images[0]
                          }
                          alt="Product"
                          style={{
                            height: "70px",
                            width: "120px",
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                        />
                      ) : (
                        "—"
                      ),

                      action: (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <Tooltip title="Edit Product">
                            <Link to={`/updateproduct/${product._id}`}>
                              <IconButton size="small" color="info">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete Product">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() =>
                                this.handleDelete(product._id)
                              }
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Products Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Products Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
